(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carte-de-contenu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-content-cards-section]');

    const setActiveDot = (dots, activeIndex) => {
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    sections.forEach((sectionEl) => {
      const track = sectionEl.querySelector('[data-track]');
      const dots = [...sectionEl.querySelectorAll('[data-dot]')];
      const slides = [...sectionEl.querySelectorAll('[data-slide]')];

      if (!track || dots.length === 0 || slides.length === 0) return;

      let ticking = false;

      const updateFromScroll = () => {
        const viewportCenter = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let minDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(slideCenter - viewportCenter);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        setActiveDot(dots, activeIndex);
      };

      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateFromScroll();
          ticking = false;
        });
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          setActiveDot(dots, index);
        });
      });

      updateFromScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
